<template>
    <table class="table mb-0 align-items-center">
        <thead>
            <tr>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">ID</th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nombre completo</th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Edad</th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Género</th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Última consulta</th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Diagnóstico Reciente
                </th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha de creación</th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha de modificación
                </th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acciones</th>
            </tr>
        </thead>
        <tbody>
            <!-- Recorre la lista completa de pacientes -->
            <tr v-for="(item) in data" :key="item.id" ref="listItems" class="table-row">
                <td class="text-center align-middle"><span class="text-sm font-weight-bold text-secondary">{{ item.id
                        }}</span></td>
                <td>
                    <div class="px-3 py-1 d-flex align-items-center">
                        <div class="avatar me-3 position-relative">
                            <img
:src="item.imageUrl || getProfilePicture(item.gender)" alt="avatar image"
                                class="card-img-top rounded-circle">
                            <!-- Badge con ID del paciente -->
                            <span
class="badge bg-gradient-primary position-absolute bottom-0 end-0 rounded-pill" 
                                  style="font-size: 0.6rem; padding: 0.2rem 0.4rem; transform: translate(25%, 25%);">
                                #{{ item.id }}
                            </span>
                        </div>
                        <div>
                            <h6 class="mb-0 text-sm">{{ item.last_name }} {{ item.first_name }}</h6>
                        </div>
                    </div>
                </td>
                <td class="text-center align-middle"><span class="text-sm font-weight-bold text-secondary">{{ item.age
                        }} años</span></td>
                <td class="text-center align-middle"><span class="text-sm font-weight-bold text-secondary">{{
                        getGender(item.gender) }}</span></td>
                <td><span class="text-sm font-weight-bold text-secondary">{{ item.last_consultation }}</span></td>
                <td><span class="text-sm font-weight-bold text-secondary">{{ item.recent_diagnosis }}</span></td>
                <td><span class="text-sm font-weight-bold text-secondary">{{ formatDate(item.created_at) }}</span></td>
                <td><span class="text-sm font-weight-bold text-primary">{{ formatDate(item.updated_at) }}</span></td>
                <td class="text-center align-middle">
                    <a
href="javascript:;"
                        @click="$emit('deleteRecord', { id: item.id, fullname: `${item.last_name} ${item.first_name}` })">
                        <i class="fa-regular fa-trash"></i>
                        <span class="sr-only">Edit Profile</span>
                    </a>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script setup>
import { getFullFormatDate, getGenderName } from '@/utils/globalFunctions.js';
import profilePicture from '@/assets/img/profile-picture.png';
import profilePictureWomen from '@/assets/img/profile-picture-women.png';

const { data } = defineProps({
    data: Array, // Ahora recibe un Array en lugar de Object
});

// Función para obtener la imagen de perfil según el género
const getProfilePicture = (gender) => {
    return gender === 'female' ? profilePictureWomen : profilePicture;
};

// Función para formatear fechas
function formatDate(dateString) {
    return getFullFormatDate(dateString);
}

// Función para obtener el género
function getGender(genderCode) {
    return getGenderName(genderCode);
}
</script>

<style scoped>
.highlight-row {
    opacity: 1;
    transition: opacity 0.2s ease-in-out;
}

.dim-row {
    opacity: 0.3;
    transition: opacity 0.2s ease-in-out;
}
</style>
